import React from 'react';
import { Zap } from 'lucide-react';

/**
 * Marks content an AI model (Gemini) wrote or read from the brief.
 *
 * The Ads Planning APIs Data Use Policy: "Generated Outputs may contain
 * inaccuracies; you will be responsible for ... reviewing and verifying them
 * before use in Media Plans". The label says so where it applies, and only
 * there: steps computed by code are not labelled AI.
 */
export const AI_LABEL_TEXT = 'AI-generated · check before use';

/**
 * The brief chat shows Gemini's text, the router's "Working..." note (it
 * stays labelled: over-labelling is safe) and one app error the router sends
 * as JSON: {"status": "error", "message": ..., "session_id": ...}, e.g.
 * "Brief document not found". Only that error is unlabelled; everything else,
 * including Gemini lines that open with ⚠️ or ❌, is AI output.
 */
export const isAppErrorJson = (text: string): boolean => {
  try {
    const parsed = JSON.parse((text || '').trim());
    return parsed !== null && typeof parsed === 'object' && parsed.status === 'error'
      && typeof parsed.message === 'string' && 'session_id' in parsed;
  } catch {
    return false;
  }
};

const AiLabel: React.FC<{ text?: string }> = ({ text = AI_LABEL_TEXT }) => (
  <span
    role="note"
    aria-label={text}
    style={{
      display: 'inline-flex', alignItems: 'center', gap: '4px',
      fontSize: '11px', fontWeight: 500, color: '#6d28d9',
      background: '#f5f3ff', border: '1px solid #ddd6fe',
      borderRadius: '999px', padding: '1px 8px', marginBottom: '6px',
    }}
  >
    <Zap size={11} aria-hidden="true" /> {text}
  </span>
);

export default AiLabel;
